import React from "react";
import AntdCalendar from 'antd/lib/calendar';
import { withError} from '@fishx/tracker';

const Calendar = (props) => <AntdCalendar {...props} />
Calendar.displayName = 'Calendar';
export default withError(Calendar)




// WEBPACK FOOTER //
// ./src/components/calendar/index.tsx